import { Stack } from "@mui/material";
import { Loader, Typography } from "@trimble/modus-cmx";
import { useTranslation } from "react-i18next";

type FullSizeLoadingProps = {
  title?: string;
};

const FullSizeLoading = (props: FullSizeLoadingProps) => {
  const { title } = props;
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{ aspectRatio: "2 / 1" }}
    >
      <Loader size="lg" />
      <Typography hierarchy="p" weight="bold" size="2xl">
        {title ?? t("loading")}
      </Typography>
    </Stack>
  );
};

export default FullSizeLoading;
